import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationProcessYandexPurchaseArgs,
  YandexPurchaseResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation ProcessYandexPurchase($playerId: String!, $purchase: JSON!, $platform: String!) {
  processYandexPurchase(playerId: $playerId, purchase: $purchase, platform: $platform) {
    currency1
  }
}
`;

export default async function mutationProcessYandexPurchase(
  args: MutationProcessYandexPurchaseArgs
) {
  return await graphqlClient.request<YandexPurchaseResult>(
    'processYandexPurchase',
    mutation,
    args
  );
}
